import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SOLICITACAO_AUTORIZACAO } from './autorizacao-api';
import { map } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})

export class AutorizacaoService {

    url: string = SOLICITACAO_AUTORIZACAO;

    constructor(private http: HttpClient, private router: Router) { }

    salvaSolicitacao(novaSolicitacao: any): Observable<any> {
        return this.http.post(this.url + '/solicita/autorizacao/salvaSolicitacao/1', novaSolicitacao)
            .pipe(map(res => res));
    }

    buscaListaUFs(): Observable<any> {
       return this.http.get(this.url +'/solicita/autorizacao/listaUFs')
                   .pipe(map(res => res));
    }

    buscaListaCidades(uf: string): Observable<string[]> {
        return this.http.get<string[]>(this.url+ `/solicita/autorizacao/cidade/list?uf=${uf}`).pipe(map(res => res));
    }

    buscaInfoBeneficiario(cdUsuario: any): Observable<any> {
        return this.http.get(this.url +'/solicita/autorizacao/infoBeneficiario/'+cdUsuario)
                    .pipe(map(res => res));
     }

    buscaFeriadoOuDesabilitado(cdEmpresa: any): Observable<any> {
      return this.http.get(this.url +'/solicita/autorizacao/mensagemFeriadoOuDesabilitado/' + cdEmpresa)
                      .pipe(map(res => res));
    }

}
